import { Component, OnInit, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { CastingMode } from '../../../att-casting-view/att-casting-view.component';
import * as _ from 'lodash';
export type CastingTextInputOptions = 'single' | 'textarea' | 'rich';
export type CastingTextOutputOptions = 'full' | 'ellipsis';

export type CastingTextInputValue = {
	input: CastingTextInputOptions;
	minChars: number;
	maxChars: number;
}
export type CastingTextDisplayValue = {
	output: CastingTextOutputOptions;
	maxChars: number;
}


@Component({
	selector: 'app-casting-text',
	templateUrl: './casting-text.component.html',
	styleUrls: ['./casting-text.component.scss']
})
export class CastingTextComponent implements OnInit, OnDestroy {

	public minChars = 0;
	public maxChars = 200000;
	private _destroyed = false;
	@Input()
	public mode: CastingMode = 'entry';
	public input: CastingTextInputOptions = 'single';
	public output: CastingTextOutputOptions = 'ellipsis';
	@Output()
	public valueChange = new EventEmitter<CastingTextDisplayValue | CastingTextInputValue>();
	@Input()
	public set value(value: CastingTextDisplayValue | CastingTextInputValue) {
		if(this._destroyed === true) {
			return;
		}
		switch (this.mode) {
			case 'display':
				this.input = (value as CastingTextInputValue).input;
				this.minChars = Number((value as CastingTextInputValue).minChars);
				this.maxChars = Number((value as CastingTextInputValue).maxChars);
				this.output = 'ellipsis';
				break;
			case 'entry':
				this.input = (value as CastingTextInputValue).input;
				this.minChars = 0;
				this.output = (value as CastingTextDisplayValue).output;
				this.maxChars = Number((value as CastingTextDisplayValue).maxChars);
				break;
		}
		if (!_.isEqual(this.value, value)) {

			this.valueChange.emit(this.value);
		}
	}

	public get value(): CastingTextInputValue | CastingTextDisplayValue {
		switch (this.mode) {
			case 'display':
				return ({
					output: this.output,
					maxChars: this.maxChars
				} as CastingTextDisplayValue);
			case 'entry':
				return ({
					input: this.input,
					minChars: this.minChars,
					maxChars: this.maxChars,
				} as CastingTextInputValue);
		}
	}



	constructor() { }

	ngOnInit(): void {

	}
	ngOnDestroy() :void {
		this._destroyed = true;
	}
	CharLimitsUpdated() {
	}
	UpdateInput(target: CastingTextInputOptions) {
		this.input = target;
		this.valueChange.emit(this.value);
	}
}
